import React, { useContext } from "react";
import './Item.css';
import whatsapp from "../assets/logo/whatsapp.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../context/ShopContext";
import { formatPrice } from "../../utils/formatPrice";
import { SHEET_EXTRA_LBS } from "../../utils/sheetPricing";

const Item = (props) => {
    const { product } = props;
    const { addToCart } = useContext(ShopContext);
    const isStartingPrice = product.category === "tailoring";
    const isContactOnly = product.subCategory === "alteration" || product.subCategory === "saree-threading" || product.subCategory === "blouse";
    const connectMessage = encodeURIComponent(`Connect~${product.name}`);
    const chatMessage = encodeURIComponent(`Chat~${product.name}`);

    const hasVariants = Array.isArray(product.variants) && product.variants.length > 0;
    // "From" should reflect the cake's default-weight full-cake price, not
    // the cheapest variant overall (boxed slice is always cheaper, but it's
    // a different product format, not a discount on the full cake).
    const fullVariants = product.variants?.filter((v) => v.format === "full") || [];
    // sheetOnly products are always in sheet mode on the product page, with a
    // mandatory quarter-sheet surcharge (the cheapest option) - the stored
    // variant price alone understates what's actually charged.
    const sheetSurcharge = product.sheetOnly ? product.lbRate * SHEET_EXTRA_LBS.quarter : 0;
    const fromPrice = hasVariants
        ? Math.min(...(fullVariants.length > 0 ? fullVariants : product.variants).map((v) => v.price)) + sheetSurcharge
        : product.new_price;

    return (
        <div>
            <div className="item">
                <div className="item-link">
                    <Link to={`/product/${product.id}`}><img src={product.image} alt="" /></Link>
                </div>
                <p>{product.name}</p>
                <div className="item-prices-container">
                    <div className="item-prices">
                        <div className="item-price-new">
                            {hasVariants ? "From " : isStartingPrice ? "Starting at " : ""}{formatPrice(fromPrice)}
                        </div>
                        {!hasVariants && product.old_price && (
                            <div className="item-price-old">
                                {formatPrice(product.old_price)}
                            </div>
                        )}
                    </div>
                    {isContactOnly ? (
                        <Link to={"https://wa.me/14249778995?text=" + connectMessage} className="cafe-button item-whatsapp-cta">
                            <span>Connect</span>
                            <img src={whatsapp} alt="" width="18px" height="" />
                        </Link>
                    ) : (
                        <>
                            <Link to={"https://wa.me/14249778995?text=" + chatMessage}>
                                <img src={whatsapp} alt="Chat on Whatsapp" width="30px" height="" />
                            </Link>

                            {hasVariants ? (
                                <Link to={`/product/${product.id}`} className="cafe-button">
                                    <span>VIEW OPTIONS</span>
                                </Link>
                            ) : (
                                <button onClick={() => { addToCart(product) }} className="cafe-button"><span>ADD TO CART</span></button>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div >
    )
}

export default Item;
